export default __webpack_public_path__ + "static/media/360-factory-visibility.4ea108f5.svg";